/**
 * Interest accruals (FSD Part 3, 3.2.3 "Accrue Interest"; V102, V108).
 * The wiring packet spreads `TREASURY_ACCRUAL_RUNS_ROUTES` into the router
 * beside `TREASURY_ROUTES` and adds the nav item (`treasury-accrual-runs`,
 * section s-3.2.3).
 *
 * Both screens are gated on `treasury.debt.read` — what `GET /debt-accrual-runs`
 * and `GET /debt-accrual-runs/:id` declare. Running an accrual needs
 * `treasury.debt.post` and recording a rate observation `treasury.debt.manage`;
 * the screens hide those actions without them.
 */

import type { RouteRecordRaw } from 'vue-router'

import { TREASURY_PERMISSIONS } from '@/modules/treasury/permissions'

import { TREASURY_ACCRUAL_RUNS_PATH } from './paths'

export { TREASURY_ACCRUAL_RUNS_PATH, accrualRunPath } from './paths'

export const TREASURY_ACCRUAL_RUNS_ROUTES: RouteRecordRaw[] = [
  {
    path: TREASURY_ACCRUAL_RUNS_PATH,
    name: 'treasury-accrual-runs',
    component: () => import('@/modules/treasury/debt/accruals/AccrualRunsView.vue'),
    meta: {
      titleKey: 'treasury.routeTitles.accrualRuns',
      permission: TREASURY_PERMISSIONS.debtRead,
    },
  },
  {
    path: `${TREASURY_ACCRUAL_RUNS_PATH}/:id(\\d+)`,
    name: 'treasury-accrual-run',
    component: () => import('@/modules/treasury/debt/accruals/AccrualRunView.vue'),
    meta: {
      titleKey: 'treasury.routeTitles.accrualRun',
      permission: TREASURY_PERMISSIONS.debtRead,
    },
  },
]
